module.exports = __webpack_public_path__ + "img/rueckrundensieger.36dc4981.png";